import { RESET_LANGUAGE, SET_LANGUAGE } from "../types";

const initialState = {
    language: 'it', 
};

const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            }
        case RESET_LANGUAGE:
            return {
                ...state,
                language: null, 
            }
        default:
            return state;
    }
};

export default languageReducer;
